import { render, staticRenderFns } from "./BrokerDashboardAnalytics.vue?vue&type=template&id=6894af0f&scoped=true&"
import script from "./BrokerDashboardAnalytics.vue?vue&type=script&lang=js&"
export * from "./BrokerDashboardAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./BrokerDashboardAnalytics.vue?vue&type=style&index=0&id=6894af0f&lang=scss&scoped=true&"
import style1 from "./BrokerDashboardAnalytics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894af0f",
  null
  
)

export default component.exports